import { toast } from 'react-toastify';
import axios from '../../axios';

import {
  ADD_COUNTRY,
  GET_COUNTRIES,
  GET_COUNTRY,
  UPDATE_COUNTRY,
  DELETE_COUNTRY,
  GET_ONE_COUNTRY
} from '../types';
import { setAlert } from './alert';

// Add Country
export const addCountry = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/country/add`,
      formData,
    );
    if (res.data.code === 1) {
      dispatch({ type: ADD_COUNTRY, payload: res.data.data });
      toast.success('Country added successfully!');
      return res.data;
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

export const updateCountryStatus = (formData) => async (dispatch) => {
  try {
    const res = await axios.post('/country/status', formData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COUNTRY, payload: res.data.data });
      setTimeout(() => {
        toast.success('Category status updated successfully!');
      }, 1000);
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
  }
};

// Get getCountries
export const getCountries = (params) => async (dispatch) => {
  try {
    // Make the request with the config object
    const res = await axios.get(
      `${process.env.REACT_APP_ADMIN_URL}/country/all`,
      { params },
    );
    if (res.data.code === 1) {
      dispatch({
        type: GET_COUNTRIES,
        payload: {
          data: res.data.data || [],
          pagination: res.data.pagination || {},
          totalCount: res.data.totalCount || 0,
        },
      });
      // dispatch({ type: GET_COUNTRIES, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Get Single Country
export const getCountry = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_ADMIN_URL}/country/${id}`,
    );
    if (res.data.code === 1) {
      dispatch({ type: GET_COUNTRY, payload: res.data.data });
      // dispatch(setAlert(res.data.message, 'success'));
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

export const clearSingleCountry = () => async (dispatch) => {
  try {
    dispatch({ type: GET_COUNTRY, payload: '' });
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

export const updateCountry = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/country/update`,
      formData,
    );
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COUNTRY, payload: res.data.data });
      setTimeout(() => {
        toast.success('Category updated successfully!');
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
  }
};
export const deleteCountry = (id) => async (dispatch) => {
  try {
    if (!id) {
      toast.warn('Please select any record');
      return false;
    }
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/country/delete/${id}`,
    );
    if (res.data.code === 1) {
      dispatch({ type: DELETE_COUNTRY, payload: { id } });
      setTimeout(() => {
        toast.success('Country deleted successfully!');
      }, 1000);
      // dispatch(setAlert(res.data.message, 'success'));
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
  }
};